import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ScreenSizeStoreService } from '../../services/scrren-size.service';
import { ScreenSize } from '../../models/screen-size.model';
import { FormControl } from '@angular/forms';
import { Column, Row } from '../../models/table';
import { LiabilityItemService } from '../../../liabilities/services/liability-item.service';
import { MatRipple } from '@angular/material/core';
import { Liability } from '../../../liabilities/models/liability.model';
import { MatMenuItem } from '@angular/material/menu';
import { SelectionModel } from '@angular/cdk/collections';
import { DesktopTableComponent } from './desktop-table/desktop.table.component';
import { HandsetService } from '../../../core/services/handset.service';
import { MobileTableComponent } from './mobile-table/mobile.table.component';
import { PageEvent } from '@angular/material/paginator';

@Component({
  standalone: false,
  selector: 'app-table',
  templateUrl: './table.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TableComponent<T extends Row> implements OnInit {
  @ViewChild(DesktopTableComponent) desktopTableComponent!: DesktopTableComponent<T>;
  @ViewChild(MobileTableComponent) mobileTableComponent!: MobileTableComponent<T>;
  @Input()
  public set totalCount(count: number) {
    this._totalCount = count;
  }


  _data: T[];

  @Input()
  public set data(value: T[]) {
    let n = !!this._data ? this._data.length : 0;
    this._data = value;
    if (this.desktopTable) {
      this.desktopTable.hideRow();
    }
    if (!!this._data && this._data.length > n) {
      this.selection.select(...this.data.filter(value => value.isSelected && !this.selection.selected
        .some(value1 => (value1.id === value.id))));
    }
  }

  public selection: SelectionModel<T> = new SelectionModel<T>(true, [], true);

  @Input() public columns: Column[];
  @Input() public initialSelected: T[];
  @Input() public isExpandable: boolean;
  @Input() public isFloatingMenu: boolean;
  @Input() public pageSize: number;
  @Input() public showDetails: boolean;
  @Input() public isSelectable: boolean;
  @Input() public multiselectDisabled: boolean;
  @Input() public editable: boolean;
  @Input() public pageable: boolean;
  public _totalCount: number;
  @Output() public addedSelection = new EventEmitter<any[]>();
  @Output() public removedSelection = new EventEmitter<any[]>();
  @Output() public rowOnclick = new EventEmitter<any>();
  @Output() public checkbox = new FormControl(false);
  @Output() public hover: boolean;
  @Output() protected expandedElement: any | null;
  @Input() expandedComponent: any;
  @Output() public matItem: MatMenuItem;
  @Input() public rowStyle: (row: T) => any;
  @Input() public rowMobileStyle: (T: any) => any;
  @Input() public showInformation: boolean;
  public isMobile = false;
  @Input() currentMonthStyle!: (T: any) => any;
  @Input() public startedPaymentId: string;
  @Output() public liabilityMarkedAsPaidEvent = new EventEmitter<void>();
  @Input() public dataL: Liability[];
  @ViewChild(MatRipple) public ripple: MatRipple;
  @ViewChild(DesktopTableComponent) public desktopTable: DesktopTableComponent<T>;
  @Input() validation?: (row: T) => boolean;
  @Output() public dataChangedEvent = new EventEmitter<{ value: T, success: boolean }>();
  @Output() public pageEvent = new EventEmitter<PageEvent>();

  @Input() public disabledMobileView: boolean;
  @Input() public hideMobileHeader: boolean;

  private _liability: Liability;
  public get liability(): Liability {
    return this._liability;
  }

  constructor(private screenSizeStore: ScreenSizeStoreService,
              public handsetService: HandsetService,
              public liabilityItemService: LiabilityItemService,
  ) {
  }

  ngOnInit(): void {
    this.screenSizeStore.getState().subscribe(value => {
      this.isMobile = (ScreenSize.XS === value || ScreenSize.S === value);
    });
    this.selection.changed.subscribe(event => {
      if (event.added.length > 0) {
        this.addedSelection.emit(event.added);
      }
      if (event.removed.length > 0) {
        this.removedSelection.emit(event.removed);
      }
    });


  }

  toggleElement(element: T) {
    if (this.handsetService.isMobile) {
      this.mobileTableComponent.toggleElement(element);
    } else {
      this.desktopTableComponent.toggleElement(element);
    }
  }

  deselectElement(element: T) {
    if (this.handsetService.isMobile) {
      this.mobileTableComponent.deselectElement(element);
    } else {
      this.desktopTableComponent.deselectElement(element);
    }
  }

  deselectElements(elements: T[]) {
    if (!!elements) {
      if (this.handsetService.isMobile) {
        elements.forEach(element => this.mobileTableComponent.deselectElement(element));
      } else {
        elements.forEach(element => this.desktopTableComponent.deselectElement(element));
      }
    }
  }

  deselectAll() {
    if (this.handsetService.isMobile) {
      this.mobileTableComponent.deselectAll();
    } else {
      this.desktopTableComponent.deselectAll();
    }
  }

  selectElements(elements: T[]) {
    if (!!elements) {
      if (this.handsetService.isMobile) {
        elements.forEach(element => this.mobileTableComponent.selectElement(element));
      } else {
        elements.forEach(element => this.desktopTableComponent.selectElement(element));
      }
    }
  }

  selectElement(element: T) {
    if (this.handsetService.isMobile) {
      this.mobileTableComponent.selectElement(element);
    } else {
      this.desktopTableComponent.selectElement(element);
    }
  }

  public get data() {
    return this._data;
  }

  get totalCount() {
    return this._totalCount;
    console.log(this._totalCount)
  }

}
